import { API_BASE_URL } from "./config";
import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import axios from "axios";
import './assets/css/main.css';
import './assets/fonts/fonts.css';
import './App.css';
import 'react-tooltip/dist/react-tooltip.css';
import Navbar from "./components/Navbar";
import MobileNavbar from "./components/MobileNavbar"; // new mobile navbar import
import PositionsEnCours from "./pages/PositionsEnCours";
import PositionsFinished from "./pages/PositionsFinished";
import PositionDetail from "./pages/PositionDetail";
import Seo from "./pages/Seo";
import QRCodes from "./pages/QRCodes";
import Login from "./pages/Login";
import SeoChecker from "./pages/SeoChecker";
import Emails from "./pages/Emails";
import DnsLookup from "./pages/DnsLookup";
import DnsPropagation from "./pages/DnsPropagation";
import PatchXgrid from "./pages/PatchXgrid";
import SitesPublies from "./pages/SitesPublies";
import SitesGestion from "./pages/SitesGestion";
import SitesVisu from "./pages/SitesVisu";
import ListeTaches from "./pages/ListeTaches";
import Clients from "./pages/Clients";
import Commandes from "./pages/Commandes";
import Calendrier from "./pages/Calendrier";
import Produits from "./pages/Produits";
import CreationTaches from "./pages/CreationTaches";
import Register from "./pages/Register";
import MainContent from "./components/MainContent";
import Logout from "./pages/Logout";
import ListeToutesTaches from "./pages/ListeToutesTaches";
import Reporting from "./pages/Reporting";
import Home from "./pages/Home";
import Client from "./pages/Client";
import Account from "./pages/Account";
import InfoBar from "./components/InfoBar";
import PositionsDeleted from "./pages/PositionsDeleted";
import Trello from "./pages/Trello";
import PositionsSuivi from "./pages/PositionsSuivi";
import Renouvellements from "./pages/Renouvellements";
import Productivity from "./pages/Productivity";
import AuthProvider from "./contexts/AuthProvider";
import BexioUpdate from "./pages/BexioUpdate";
import MainSearchBar from "./components/MainSearchBar";
import Tickets from "./pages/Tickets";
import Ticket from "./pages/Ticket";
import MesTickets from "./pages/MesTickets";
import MesTicketsAssignes from "./pages/MesTicketsAssignes";
import UsersList from "./pages/UsersList";
import XError from "./pages/XError";
import SectionTechniqueDetailsResume from "./components/Client/SectionTechniqueDetailsResume";
import ReportingClients from "./pages/Reporting/ReportingClients";
import User from "./pages/User";
import ResetPassword from "./pages/ResetPassword";
import DeletedUsersList from "./pages/DeletedUsersList";
import SupportTicket from "./pages/Support/SupportTicket";
import SupportTicketSuccess from "./pages/Support/SupportTicketSucces";
import Scripts from "./pages/Scripts";
import MdpGenFTP from "./pages/MdpGenFTP";
import MdpGenDomain from "./pages/MdpGenDomain";
import Downtime from "./pages/Downtime";
import SecurityReport from "./pages/SecurityReport";
import SitesSecurite from "./pages/SitesSecurite";

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loadingAuth, setLoadingAuth] = useState(true);
    const token = localStorage.getItem('token');
    const userId = localStorage.getItem('user_id');
    const [isNavbarToggled, setIsNavbarToggled] = useState(localStorage.getItem('navbar_state') === 'true');
    const [isMobileNavbarToggled, setIsMobileNavbarToggled] = useState(localStorage.getItem('navbar_state') === 'false' || false);
    const [infoBarVisible, setInfoBarVisible] = useState(true);
    const [contentWidthOffset, setContentWidthOffset] = useState('380px');
    const [contentLeftOffset, setContentLeftOffset] = useState('380px');
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const location = useLocation();


    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
            //console.log(window.innerWidth)
        };

        console.log(window.innerWidth)
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleNavbar = () => {
        setIsNavbarToggled(prevState => {
            const newState = !prevState;
            localStorage.setItem('navbar_state', newState);
            return newState;
        });
    };

    const toggleMobileNavbar = () => {
        setIsMobileNavbarToggled(prevState => {
            const newState = !prevState;
            localStorage.setItem('mobile_navbar_state', !prevState);
            return newState;
        });
    };

    useEffect(() => {
        // Adjust the left offset for main content based on OS
        function detectOS() {
            const userAgent = navigator.userAgent || window.opera;
            if (/Win/i.test(userAgent)) return "Windows";
            if (/Mac/i.test(userAgent)) return "Mac";
            return "Other";
        }

        const os = detectOS();
        const widthOffset = os === "Windows" ? "380px" : "380px";
        const leftOffset = os === "Windows" ? "380px" : "380px";
        setContentWidthOffset(widthOffset);
        setContentLeftOffset(leftOffset);
    }, []);

    const closeInfobar = () => {
        setInfoBarVisible(false);
    };

    // Déconnecte si le compte est locked ou que le token est supprimé
    useEffect(() => {
        const checkAuth = async () => {
            if (token && userId) {
                try {
                    const response = await axios.post(`${API_BASE_URL}/check_auth`, { token, userId });
                    if (response.data && response.data.status === 'ok') {
                        setIsAuthenticated(true);
                    } else {
                        setIsAuthenticated(false);
                        localStorage.removeItem('token');
                        localStorage.removeItem('user_id');
                    }
                    console.log('auth')
                } catch (error) {
                    console.error('Error checking authentication:', error);
                    setIsAuthenticated(false);
                }
            } else {
                setIsAuthenticated(false);
            }
            setLoadingAuth(false);
        };

        checkAuth()

    }, [location.pathname, token, userId]);

    // While authentication is loading, you could show a loading indicator
    if (loadingAuth) {
        return null;
    }

    return (<AuthProvider>
        <div className="App">

            <div className="display-flex">

                {isAuthenticated &&
                    <>
                        {/* Toggle button now inside Navbar.jsx */}


                        {screenWidth >= 1200 ? (<div className={isNavbarToggled ? 'navbar-expanded' : 'navbar-collapsed'}>
                            <Navbar isNavbarToggled={isNavbarToggled} setIsNavbarToggled={setIsNavbarToggled} toggleNavbar={toggleNavbar} />
                        </div>) : (
                            <>
                                {/* Toggle button for Mobile is now inside MainSearchBar.jsx */}

                                <div
                                    className={`mobile-navbar ${isMobileNavbarToggled ? 'mobile-navbar-visible' : 'mobile-navbar-hidden'}`}>
                                    <MobileNavbar toggleNavbar={toggleMobileNavbar} />
                                </div>
                            </>)}
                    </>
                }

                {isAuthenticated && (
                    <MainSearchBar
                        isNavbarToggled={isNavbarToggled}
                        toggleNavbar={toggleNavbar}
                        isMobileNavbarToggled={isMobileNavbarToggled}
                        toggleMobileNavbar={toggleMobileNavbar}
                        screenWidth={screenWidth}
                    />
                )}

                {/* Main content area that shifts based on navbar visibility */}
                <div
                    className={`main-content 
                    ${screenWidth > 1200 ? (isNavbarToggled ? 'content-collapsed' : 'content-expanded') : ''} 
                    ${screenWidth < 1200 ? (isMobileNavbarToggled ? 'content-mobile-collapsed' : 'content-mobile-expanded') : ''}`}
                    style={{
                        left:
                            screenWidth > 1200
                                ? (isNavbarToggled ? '380px' : '0')
                                : (isMobileNavbarToggled ? '380px' : '0'),
                        width:
                            screenWidth > 1200
                                ? (isNavbarToggled ? `calc(100vw - 380px)` : '100%')
                                : (isMobileNavbarToggled ? `calc(100vw - 380px)` : '100%'),
                    }}
                >
                    {isAuthenticated && infoBarVisible && (
                        <InfoBar closeInfoBar={closeInfobar} type="warning" data="" />
                    )}

                    <MainContent>
                        <Routes>
                            <Route path="/resetpassword" element={<ResetPassword />} />
                            <Route path="/contact-us" element={<SupportTicket />} />
                            <Route path="/support-ticket-success" element={<SupportTicketSuccess />} />

                            {isAuthenticated ? (
                                <>
                                    <Route path="/" element={<Home />} />
                                    <Route path="/positions/:position_id" element={<PositionDetail />} />
                                    <Route path="/seo" element={<Seo />} />
                                    <Route path="/seo-checker" element={<SeoChecker />} />
                                    <Route path="/qrcodes" element={<QRCodes />} />
                                    <Route path="/emails" element={<Emails />} />
                                    <Route path="/dns-lookup" element={<DnsLookup />} />
                                    <Route path="/dns-propagation" element={<DnsPropagation />} />
                                    <Route path="/patch-xgrid" element={<PatchXgrid />} />
                                    <Route path="/sites-gestion" element={<SitesGestion />} />
                                    <Route path="/sites-publies" element={<SitesPublies />} />
                                    <Route path="/sites-securite" element={<SitesSecurite />} />
                                    <Route path="/sites-visu" element={<SitesVisu />} />
                                    <Route path="/liste-taches" element={<ListeTaches />} />
                                    <Route path="/tickets" element={<Tickets />} />
                                    <Route path="/mes-tickets" element={<MesTickets />} />
                                    <Route path="/mes-tickets-assignes" element={<MesTicketsAssignes />} />
                                    <Route path="/ticket/:id" element={<Ticket />} />
                                    <Route path="/calendrier" element={<Calendrier />} />
                                    <Route path="/trello" element={<Trello />} />
                                    <Route path="/clients" element={<Clients />} />
                                    <Route path="/commandes-en-cours" element={<Commandes />} />
                                    <Route path="/projets-en-cours" element={<PositionsEnCours />} />
                                    <Route path="/projets-en-suivi" element={<PositionsSuivi />} />
                                    <Route path="/projets-termines" element={<PositionsFinished />} />
                                    <Route path="/maj-bexio" element={<BexioUpdate />} />
                                    <Route path="/produits" element={<Produits />} />
                                    <Route path="/creation-taches" element={<CreationTaches />} />
                                    <Route path="/logout" element={<Logout />} />
                                    <Route path="/client/:id" element={<Client />} />
                                    <Route path="/client/:id#customer-list" element={<SectionTechniqueDetailsResume />} />
                                    <Route path="/account" element={<Account />} />
                                    <Route path="/mdp-gen-domain" element={<MdpGenDomain />} />

                                    {localStorage.user_role === "Administrateur" && (
                                        <>
                                            {(localStorage.user_id === '61' || localStorage.user_id === '58' || localStorage.user_id === '27' || localStorage.user_id === '8') && <Route path="/mdp-gen-ftp" element={<MdpGenFTP />} />}

                                            <Route path="/scripts" element={<Scripts />} />
                                            <Route path="/reporting" element={<Reporting />} />
                                            <Route path="/utilisateurs" element={<UsersList />} />
                                            <Route path="/utilisateurs-supprimes" element={<DeletedUsersList />} />
                                            <Route path="/renouvellements" element={<Renouvellements />} />
                                            <Route path="/productivite" element={<Productivity />} />
                                            <Route path="/utilisateur/:id" element={<User />} />
                                            <Route path="/reporting-clients" element={<ReportingClients />} />
                                            <Route path="/liste-toutes-taches" element={<ListeToutesTaches />} />
                                            <Route path="/projets-supprimes" element={<PositionsDeleted />} />
                                            <Route path="/register" element={<Register />} />
                                            <Route path="/xerror" element={<XError />} />
                                            <Route path="/downtime/:url" element={<Downtime />} />
                                            <Route path="/rapport-securite/:url" element={<SecurityReport />} />
                                        </>
                                    )}
                                </>
                            ) : (
                                // not authed: everything (except /resetpassword) shows Login
                                <Route path="*" element={<Login />} />
                            )}
                        </Routes>
                    </MainContent>

                </div>

            </div>
        </div>
    </AuthProvider>);
}

export default App;